import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_2 = {
  key: 0,
  class: "readonly-banner"
}
const _hoisted_3 = { class: "form-row" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  class: "form-row"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-row" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "error-text"
}
const _hoisted_16 = { class: "services-section" }
const _hoisted_17 = { class: "form-row" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = ["onUpdate:modelValue", "onChange", "disabled"]
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 0,
  class: "form-group"
}
const _hoisted_22 = ["onUpdate:modelValue", "disabled"]
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 1,
  class: "form-group"
}
const _hoisted_25 = ["onUpdate:modelValue", "disabled"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 1,
  class: "form-group"
}
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["value"]
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  key: 2,
  class: "form-group"
}
const _hoisted_32 = { class: "voucher-row" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 1,
  class: "hint-text"
}
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 3,
  class: "payment-section"
}
const _hoisted_39 = { class: "price-summary" }
const _hoisted_40 = { class: "price-row" }
const _hoisted_41 = {
  key: 0,
  class: "price-row discount"
}
const _hoisted_42 = { class: "price-row highlight" }
const _hoisted_43 = { class: "form-row" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  key: 1,
  class: "price-row tips-row"
}
const _hoisted_49 = {
  key: 4,
  class: "total-bill"
}
const _hoisted_50 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'modal-backdrop': !_ctx.isEmbedded }),
    onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (!_ctx.isEmbedded && _ctx.close()), ["self"]))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'modal-content': !_ctx.isEmbedded })
    }, [
      (!_ctx.isEmbedded)
        ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.isEditMode ? 'Edit Appointment' : 'Create New Appointment'), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
              class: "btn-close"
            }, "×")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", {
        class: _normalizeClass({ 'modal-body': !_ctx.isEmbedded })
      }, [
        (_ctx.readOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.appointment?.status === 'completed')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Payment has been recorded. This appointment is completed and cannot be edited. ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" This appointment cannot be edited. ")
                  ], 64))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
          class: "booking-form"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { for: "customer" }, "Customer", -1)),
              _createElementVNode("input", {
                type: "text",
                id: "customer",
                value: `${_ctx.customer?.firstName} ${_ctx.customer?.lastName}`,
                disabled: ""
              }, null, 8, _hoisted_5)
            ])
          ]),
          (_ctx.isEditMode && _ctx.isStaffProps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { for: "status" }, "Status", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "status",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.status) = $event)),
                    disabled: _ctx.readOnly
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editableStatuses, (s) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: s,
                        value: s
                      }, _toDisplayString(_ctx.statusLabels[s]), 9, _hoisted_9))
                    }), 128))
                  ], 8, _hoisted_8), [
                    [_vModelSelect, _ctx.form.status]
                  ]),
                  _cache[20] || (_cache[20] = _createElementVNode("small", { class: "hint-text" }, "To complete, record payment below — status will update automatically.", -1))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[21] || (_cache[21] = _createElementVNode("label", { for: "appointmentDate" }, "Date", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                id: "appointmentDate",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.appointmentDate) = $event)),
                required: "",
                disabled: _ctx.readOnly
              }, null, 8, _hoisted_12), [
                [_vModelText, _ctx.form.appointmentDate]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[22] || (_cache[22] = _createElementVNode("label", { for: "appointmentTime" }, "Time", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "time",
                id: "appointmentTime",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.time) = $event)),
                required: "",
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.validateTime && _ctx.validateTime(...args))),
                disabled: _ctx.readOnly
              }, null, 40, _hoisted_14), [
                [_vModelText, _ctx.form.time]
              ]),
              (_ctx.timeError)
                ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_ctx.timeError), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[28] || (_cache[28] = _createElementVNode("h3", null, "Services", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.services, (service, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "service-item"
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _cache[24] || (_cache[24] = _createElementVNode("label", null, "Service", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((service.serviceId) = $event),
                      onChange: ($event: any) => (_ctx.updateServicePrice(index)),
                      required: "",
                      disabled: _ctx.readOnly
                    }, [
                      _cache[23] || (_cache[23] = _createElementVNode("option", {
                        disabled: "",
                        value: ""
                      }, "Select a service", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.availableServices as Service[]), (s) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: s.id,
                          value: s.id
                        }, _toDisplayString(s.name), 9, _hoisted_20))
                      }), 128))
                    ], 40, _hoisted_19), [
                      [_vModelSelect, service.serviceId]
                    ])
                  ]),
                  (_ctx.isStaffProps)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _cache[26] || (_cache[26] = _createElementVNode("label", null, "Employee", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((service.employeeId) = $event),
                          disabled: _ctx.readOnly
                        }, [
                          _cache[25] || (_cache[25] = _createElementVNode("option", { value: "" }, "Any Available", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (employee) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: employee.id,
                              value: employee.id
                            }, _toDisplayString(employee.firstName) + " " + _toDisplayString(employee.lastName), 9, _hoisted_23))
                          }), 128))
                        ], 8, _hoisted_22), [
                          [_vModelSelect, service.employeeId]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isStaffProps)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _cache[27] || (_cache[27] = _createElementVNode("label", null, "Price (₹)", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((service.price) = $event),
                          min: "0",
                          step: "0.01",
                          placeholder: "0.00",
                          disabled: !service.serviceId || _ctx.readOnly
                        }, null, 8, _hoisted_25), [
                          [
                            _vModelText,
                            service.price,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.readOnly)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: ($event: any) => (_ctx.removeService(index)),
                      class: "btn-remove-service"
                    }, "Remove", 8, _hoisted_26))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (!_ctx.readOnly)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addService && _ctx.addService(...args))),
                  class: "btn btn-secondary"
                }, "Add Service"))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isStaffProps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _cache[30] || (_cache[30] = _createElementVNode("label", { for: "offer" }, "Offer (Optional)", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "offer",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.offerId) = $event)),
                  disabled: _ctx.readOnly || !!_ctx.form.spinVoucherCode,
                  onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onOfferChange && _ctx.onOfferChange(...args)))
                }, [
                  _cache[29] || (_cache[29] = _createElementVNode("option", { value: null }, "No offer", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeOffers, (offer) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: offer.id,
                      value: offer.id
                    }, _toDisplayString(_ctx.formatOfferLabel(offer)), 9, _hoisted_29))
                  }), 128)),
                  (_ctx.voucherOffer && !_ctx.activeOffers.some(o => o.id === _ctx.voucherOffer.id))
                    ? (_openBlock(), _createElementBlock("option", {
                        key: 0,
                        value: _ctx.voucherOffer.id
                      }, _toDisplayString(_ctx.formatOfferLabel(_ctx.voucherOffer)) + " (spin voucher) ", 9, _hoisted_30))
                    : _createCommentVNode("", true)
                ], 40, _hoisted_28), [
                  [_vModelSelect, _ctx.form.offerId]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isStaffProps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _cache[31] || (_cache[31] = _createElementVNode("label", { for: "spinVoucherCode" }, "Spin voucher code (Optional)", -1)),
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    id: "spinVoucherCode",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.spinVoucherCode) = $event)),
                    type: "text",
                    placeholder: "e.g. DIWALI-ABC123",
                    disabled: _ctx.readOnly,
                    onKeyup: _cache[9] || (_cache[9] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.applySpinVoucher && _ctx.applySpinVoucher(...args)), ["prevent"]), ["enter"]))
                  }, null, 40, _hoisted_33), [
                    [_vModelText, _ctx.form.spinVoucherCode]
                  ]),
                  (!_ctx.readOnly)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-secondary btn-apply-voucher",
                        disabled: !_ctx.form.spinVoucherCode.trim() || _ctx.voucherLoading,
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.applySpinVoucher && _ctx.applySpinVoucher(...args)))
                      }, _toDisplayString(_ctx.voucherLoading ? 'Checking…' : 'Apply'), 9, _hoisted_34))
                    : _createCommentVNode("", true),
                  (!_ctx.readOnly && _ctx.form.spinVoucherCode)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.clearSpinVoucher && _ctx.clearSpinVoucher(...args)))
                      }, " Clear "))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.voucherMessage)
                  ? (_openBlock(), _createElementBlock("small", {
                      key: 0,
                      class: _normalizeClass(["hint-text", { 'voucher-error': _ctx.voucherError }])
                    }, _toDisplayString(_ctx.voucherMessage), 3))
                  : (_openBlock(), _createElementBlock("small", _hoisted_35, " Enter the customer’s spin code to apply their prize. Cannot combine with another offer. "))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_36, [
            _cache[32] || (_cache[32] = _createElementVNode("label", { for: "notes" }, "Notes (Optional)", -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "notes",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.notes) = $event)),
              rows: "3",
              disabled: _ctx.readOnly
            }, null, 8, _hoisted_37), [
              [_vModelText, _ctx.form.notes]
            ])
          ]),
          (_ctx.isStaffProps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _cache[40] || (_cache[40] = _createElementVNode("h3", null, "Billing & Payment", -1)),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _cache[33] || (_cache[33] = _createElementVNode("span", null, "Total Bill (services)", -1)),
                    _createElementVNode("strong", null, "₹" + _toDisplayString(_ctx.subtotal.toFixed(2)), 1)
                  ]),
                  (_ctx.discountAmount > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _cache[34] || (_cache[34] = _createElementVNode("span", null, "Discount", -1)),
                        _createElementVNode("strong", null, "- ₹" + _toDisplayString(_ctx.discountAmount.toFixed(2)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_42, [
                    _cache[35] || (_cache[35] = _createElementVNode("span", null, "Amount After Discount", -1)),
                    _createElementVNode("strong", null, "₹" + _toDisplayString(_ctx.amountAfterDiscount.toFixed(2)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _cache[36] || (_cache[36] = _createElementVNode("label", { for: "amountReceived" }, "Amount Received (₹)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "amountReceived",
                      type: "number",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.amountReceived) = $event)),
                      min: "0",
                      step: "0.01",
                      placeholder: "Actual amount paid",
                      disabled: _ctx.readOnly
                    }, null, 8, _hoisted_45), [
                      [
                        _vModelText,
                        _ctx.form.amountReceived,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _cache[37] || (_cache[37] = _createElementVNode("small", { class: "hint-text" }, [
                      _createTextVNode("Enter the amount the customer paid. Saving will mark this appointment as "),
                      _createElementVNode("strong", null, "completed"),
                      _createTextVNode(" and lock further edits.")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", { for: "tips" }, "Tips (₹)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "tips",
                      type: "number",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.tips) = $event)),
                      min: "0",
                      step: "0.01",
                      placeholder: "0.00",
                      disabled: _ctx.readOnly
                    }, null, 8, _hoisted_47), [
                      [
                        _vModelText,
                        _ctx.form.tips,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ]),
                (_ctx.paymentAdjustment != null && _ctx.paymentAdjustment !== 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["price-row adjustment", _ctx.adjustmentClass])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.adjustmentLabel), 1),
                      _createElementVNode("strong", null, "₹" + _toDisplayString(_ctx.adjustmentDisplayAmount), 1)
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.form.tips > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _cache[39] || (_cache[39] = _createElementVNode("span", null, "Total Collected (received + tips)", -1)),
                      _createElementVNode("strong", null, "₹" + _toDisplayString(_ctx.totalCollected.toFixed(2)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.showPrice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("strong", null, "Total: ₹" + _toDisplayString(_ctx.amountAfterDiscount.toFixed(2)), 1)
                ]))
              : _createCommentVNode("", true),
          (!_ctx.readOnly)
            ? (_openBlock(), _createElementBlock("footer", {
                key: 5,
                class: _normalizeClass(["form-footer", { 'modal-footer': !_ctx.isEmbedded }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, "Cancel"),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary",
                  disabled: _ctx.isSubmitting
                }, _toDisplayString(_ctx.submitButtonLabel), 9, _hoisted_50)
              ], 2))
            : _createCommentVNode("", true)
        ], 32)
      ], 2)
    ], 2)
  ], 2))
}